import { render, staticRenderFns } from "./MoshaverChilds.vue?vue&type=template&id=689a3568&scoped=true&"
import script from "./MoshaverChilds.vue?vue&type=script&lang=js&"
export * from "./MoshaverChilds.vue?vue&type=script&lang=js&"
import style0 from "./MoshaverChilds.vue?vue&type=style&index=0&id=689a3568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689a3568",
  null
  
)

export default component.exports